<template>
  <div>
    <b-alert
      show
      v-if="runningVersionRelative() > 0"
      variant="warning"
      style="position: absolute; opacity: 0.85; width: 100%"
      class="px-4 py-1"
    >
      <h6 style="text-align: center">Being built and deployed...</h6>
    </b-alert>

    <b-alert
      show
      v-if="runningVersionRelative() < 0"
      variant="warning"
      style="position: absolute; opacity: 0.8; width: 100%; z-index: 1000"
      class="px-4 py-1"
    >
      <div v-if="aboutToAutoUpdateNow">
        <br />
        <br />
        <h1 style="text-align: center">Updating app</h1>
        <br />
        <br />
      </div>
      <div v-else>
        <h5 style="text-align: center; font-size: 71%">
          App updating in
          {{ $route.meta.gracePeriodMinutesBeforeAutoUpdate }} minutes
          <b-button
            @click="warnAndDoAutoUpdate"
            variant="warning"
            size="sm"
            class="ml-2 py-0 px-2"
            >Update now</b-button
          >
        </h5>
      </div>
    </b-alert>
  </div>
</template>

<script>
import { BUILDVERSION } from "@/utils/buildVersion.js"; // This is overwritten by the building process

import {
  systemStatusRef, // just in the global space, non- "this."
} from "@/utils/firebase.js";

import { getNewest } from "@/utils/getNewest.js"; // but remember to also re-export it in methods

export default {
  data: function () {
    return {
      aboutToAutoUpdateNow: false, // Will write to this once have $ROUTE and LATESTVERSION
      runningVersion: BUILDVERSION,
      latestVersion: "",
      latestVersionRead: false,
      pendingUpdateTimeoutId: null,
    };
  },

  watch: {
    $route: function () {
      this.reconsiderAutoUpdate();
    },
  },

  created() {
    this.latestVersionCallback = systemStatusRef
      .child("latestVersion")
      .on("value", (snapshot) => {
        this.latestVersion = snapshot.val() || null;
        this.latestVersionRead = true;
        this.reconsiderAutoUpdate();
      });
  },

  beforeDestroy() {
    this.cancelPendingUpdate();
    systemStatusRef
      .child("latestVersion")
      .off("value", this.latestVersionCallback);
  },

  methods: {
    runningVersionRelative: function () {
      if (this.latestVersionRead) {
        if (this.runningVersion > this.latestVersion) {
          return +1; // The version running is NEWER than the one listed on firebase, which will happen if you have half-run the build script and then aborted it or (while it runs) are serving it locally via NPM RUN DEV.
        } else if (this.runningVersion < this.latestVersion) {
          return -1; // The version running is OLDER than the one listed on firebase, which means you should update
        } else {
          return 0; // You are up to date
        }
      }
      return undefined;
    },

    cancelPendingUpdate() {
      if (this.pendingUpdateTimeoutId !== null) {
        clearTimeout(this.pendingUpdateTimeoutId);
        this.pendingUpdateTimeoutId = null;
      }
    },

    // Called whenever either input changes: the latest version from Firebase,
    // or the route we are on. It always replaces any previously scheduled
    // update, so exactly one timer is ever outstanding.
    //
    // This used to take a "canUpdateImmediately" flag, which the $route watcher
    // passed as true to force the grace period to zero. That existed only
    // because there was no way to cancel an already-scheduled update. It also
    // misfired: the watcher runs AFTER the new route is active, so navigating
    // INTO a module reloaded the student on arrival, discarding the very grace
    // period that route was asking for. With a cancellable timer the route's own
    // gracePeriodMinutesBeforeAutoUpdate expresses the whole policy - arriving
    // somewhere with a grace of 0 (home, welcome, academy list) still updates
    // straight away, because that is what a zero-length timer does.
    reconsiderAutoUpdate() {
      this.cancelPendingUpdate();

      const relative = this.runningVersionRelative();
      if (relative === undefined || relative >= 0) {
        return; // Not read from Firebase yet, or we are already up to date
      }

      const graceMinutes =
        this.$route.meta.gracePeriodMinutesBeforeAutoUpdate || 0;
      this.pendingUpdateTimeoutId = setTimeout(
        this.warnAndDoAutoUpdate,
        graceMinutes * 60 * 1000
      );
    },
    warnAndDoAutoUpdate() {
      this.aboutToAutoUpdateNow = true;
      setTimeout(getNewest, 500);
    },

    //
    getNewest, // Copy from GLOBAL (imported area) to THIS, so the TEMPLATE can use this in @click
  },
};
</script>

<style>
</style>
